'use strict';

var curry2 = require('../_internal/_curry2');

var equals = require('./equals');

module.exports = curry2(equals);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/equals/index.js
// module id = 520
// module chunks = 0